import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {withTranslation} from "react-i18next";

const GeometriesWarningDialog = ({t, isOpen, onClose}) => (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogContent onClose={onClose}>{t("components.map.dialogs.noGeometry.title")}</DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{t("commons.confirm.close")}</Button>
    </DialogActions>
  </Dialog>
);

export default withTranslation()(GeometriesWarningDialog);
